module.exports = __webpack_public_path__ + "static/img/logo-bl.d922a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-bl.png
// module id = fwt4
// module chunks = 14